// components/Sender/TestSendDialog.js
import React, { useState, useEffect } from "react";
import { SenderApi } from "./SenderApi";

const ERR_HINTS = {
  GMAIL_AUTH_FAIL:         "Протух refresh_token или в конфиге нет client_id / client_secret. Перевыпусти токен в Google Cloud Console и залей в канал воркера.",
  GMAIL_PERM_FAIL:         "У OAuth-приложения нет scope gmail.send. Проверь SCOPES в скрипте, который выпускает токен, и перевыпусти.",
  GMAIL_RATE:              "Google rate limit — подожди и повтори.",
  GMAIL_CONN_FAIL:         "Сетевая ошибка при обращении к Google.",
  SMTP_AUTH_FAIL:          "Неверный логин/пароль. Для Gmail/Yandex нужен app-password, а не обычный пароль.",
  SMTP_CONN_FAIL:          "Проверь host / port / шифрование / сеть.",
  SMTP_SENDER_REFUSED:     "Сервер не принял from_email — обычно нужен подтверждённый sender.",
  SMTP_RECIPIENT_REFUSED:  "Сервер отверг адрес получателя.",
  SMTP_HELO_FAIL:          "Сервер отверг EHLO — проблема на стороне SMTP.",
  SMTP_DATA_5XX:           "Спам-фильтр сервера отверг письмо. Проверь содержимое / репутацию домена.",
};

function hint(errText) {
  const up = (errText || "").toUpperCase();
  for (const k of Object.keys(ERR_HINTS)) {
    if (up.includes(k)) return ERR_HINTS[k];
  }
  return "";
}

const STATUS_STYLE = {
  idle:    { bg: "#f9fafb", fg: "#6b7280" },
  success: { bg: "#dcfce7", fg: "#166534" },
  warn:    { bg: "#fef3c7", fg: "#b45309" },
  error:   { bg: "#fee2e2", fg: "#b91c1c" },
};

export function TestSendDialog({ workers, onClose, add }) {
  const [workerId, setWorkerId] = useState(workers?.[0]?.id || "");
  const [transport, setTransport] = useState("—");
  const [fromEmail, setFromEmail] = useState("—");
  const [to, setTo] = useState("");
  const [subject, setSubject] = useState("Outreach Worker — тестовое письмо");
  const [body, setBody] = useState(
    "Привет!\n\nЭто тестовое сообщение от Outreach Worker.\n" +
    "Если ты его видишь — канал настроен правильно.\n"
  );
  const [status, setStatus] = useState({ kind: "idle", text: "" });
  const [sending, setSending] = useState(false);

  // при смене воркера — тянем каналы
  useEffect(() => {
    if (!workerId) return;
    setTransport("—");
    setFromEmail("—");
    setStatus({ kind: "idle", text: "⏳ Загружаю каналы…" });
    (async () => {
      try {
        const data = await SenderApi.getWorkerChannels(workerId);
        const em = (data?.channels || {})["EMAIL"];
        if (!em) {
          setTransport("нет EMAIL");
          setStatus({ kind: "warn", text: "⚠️ У воркера нет EMAIL-канала" });
          return;
        }
        const t = em.transport ||
          ((em.provider || "").toUpperCase() === "SMTP" ? "SMTP" : "GMAIL_API");
        setTransport(t);
        const frm = em.from_email || em.email || em.username || "—";
        setFromEmail(frm);
        if (!to && frm !== "—") setTo(frm);
        setStatus({ kind: "idle", text: "Готов к отправке." });
      } catch (e) {
        setStatus({ kind: "error", text: "⚠️ Не удалось получить каналы: " + e.message });
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [workerId]);

  const send = async () => {
    if (!to.includes("@")) {
      setStatus({ kind: "error", text: "Укажи корректный email получателя" });
      return;
    }
    setSending(true);
    setStatus({ kind: "idle", text: `⏳ Отправляю через ${transport}…` });
    try {
      const res = await SenderApi.testSend({
        worker_id: workerId, to, subject, body,
      });
      if (res?.ok) {
        setStatus({ kind: "success", text: `✅ Отправлено на ${to} через ${transport}` });
        add?.("✉️ Тестовое письмо отправлено", "success");
      } else {
        const err = res?.error || "неизвестно";
        setStatus({
          kind: "error",
          text: `❌ ${err}${hint(err) ? "\n" + hint(err) : ""}`,
        });
      }
    } catch (e) {
      setStatus({ kind: "error", text: `❌ ${e.message}` });
    } finally {
      setSending(false);
    }
  };

  const sc = STATUS_STYLE[status.kind] || STATUS_STYLE.idle;

  return (
    <div style={{
      position: "fixed", inset: 0, background: "rgba(0,0,0,.6)",
      backdropFilter: "blur(3px)", zIndex: 1200,
      display: "flex", alignItems: "center", justifyContent: "center",
      padding: 20,
    }} onClick={onClose}>
      <div onClick={(e) => e.stopPropagation()} style={{
        background: "#fff", borderRadius: 14, width: "100%",
        maxWidth: 760, maxHeight: "92vh", display: "flex",
        flexDirection: "column", overflow: "hidden",
      }}>
        <div style={{
          padding: "16px 20px", borderBottom: "1.5px solid #e5e7eb",
          display: "flex", justifyContent: "space-between", alignItems: "center",
        }}>
          <div>
            <h3 style={{ margin: 0 }}>✉️ Тестовая отправка</h3>
            <div style={{ fontSize: 12, color: "#6b7280", marginTop: 4 }}>
              Реально отправит одно письмо. В БД не пишется.
            </div>
          </div>
          <button className="btn-cancel" onClick={onClose}>✕</button>
        </div>

        <div style={{ flex: 1, overflow: "auto", padding: 20,
                      display: "flex", flexDirection: "column", gap: 12 }}>
          <div>
            <label className="form-label">Воркер</label>
            <select className="form-input"
                    value={workerId}
                    onChange={(e) => setWorkerId(parseInt(e.target.value, 10))}>
              {workers.map((w) => (
                <option key={w.id} value={w.id}>
                  {w.name || w.worker_name}
                </option>
              ))}
            </select>
          </div>

          <div style={{ display: "flex", gap: 16, flexWrap: "wrap",
                        padding: "8px 12px", background: "#f0f9ff",
                        borderRadius: 8, fontSize: 13, color: "#075985" }}>
            <div><b>Транспорт:</b> {transport}</div>
            <div><b>Отправитель:</b> {fromEmail}</div>
          </div>

          <div>
            <label className="form-label">Кому</label>
            <input className="form-input" value={to}
                   placeholder="recipient@example.com"
                   onChange={(e) => setTo(e.target.value)} />
          </div>
          <div>
            <label className="form-label">Тема</label>
            <input className="form-input" value={subject}
                   onChange={(e) => setSubject(e.target.value)} />
          </div>
          <div>
            <label className="form-label">Тело</label>
            <textarea className="form-input"
                      style={{ minHeight: 160, fontFamily: "inherit" }}
                      value={body}
                      onChange={(e) => setBody(e.target.value)} />
          </div>

          {status.text && (
            <div style={{
              padding: "10px 12px", borderRadius: 8,
              background: sc.bg, color: sc.fg,
              whiteSpace: "pre-wrap", fontSize: 13, lineHeight: 1.5,
            }}>
              {status.text}
            </div>
          )}
        </div>

        <div style={{ padding: "12px 20px", borderTop: "1.5px solid #e5e7eb",
                      display: "flex", justifyContent: "flex-end", gap: 8 }}>
          <button className="btn-cancel" onClick={onClose}>Закрыть</button>
          <button className="btn-primary"
                  style={{ minWidth: 180 }}
                  disabled={sending}
                  onClick={send}>
            {sending ? "⏳ Отправка…" : "✉️ Отправить"}
          </button>
        </div>
      </div>
    </div>
  );
}